module.exports = __webpack_public_path__ + "static/media/assign child.c94a8349.svg";